import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * The connection to the band's own Supabase project.
 *
 * Both values below are safe to ship in the browser: the publishable key only
 * grants what the database's row-level security policies explicitly allow —
 * anyone may read the published site and submit the VIP form, while changing
 * the site requires being signed in as an owner.
 */
export const supabaseUrl = 'https://ooopgxwcncfemqxetpkx.supabase.co';
export const supabasePublishableKey = 'sb_publishable_4xIErUpZCwfDcjyfXQFKPw_Et5n30Z9';

/** The storage bucket that holds every uploaded photo. */
export const photoBucket = 'photos';

export const supabase: SupabaseClient = createClient(supabaseUrl, supabasePublishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Left on the default flow so a sign-in link still works when the email is
    // opened on a different device from the one that requested it.
    detectSessionInUrl: true,
  },
});

export function isCloudConfigured(): boolean {
  return Boolean(supabaseUrl && supabasePublishableKey);
}

/** Where a sign-in email should send someone back to. */
export function studioRedirectUrl(): string {
  return `${window.location.origin}/studio`;
}
